import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const REASONS = ["Physical Verification", "Wastage", "Spoilage", "Breakage", "Other"];

export function StockAdjustDialog({ item, open, onClose, onDone }) {
  const [adjType, setAdjType] = useState("decrease");
  const [qty, setQty] = useState("");
  const [reason, setReason] = useState("Physical Verification");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/inventory/adjust", { inventory_id: item.id, adj_type: adjType, quantity: Number(qty), reason });
      toast.success("Stock adjusted & recorded");
      setQty(""); onDone && onDone(); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!item) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-brand-bg max-w-sm" data-testid="stock-adjust-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-tight text-left">Adjust Stock</DialogTitle>
          <DialogDescription className="sr-only">Record a manual stock adjustment</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-brand-muted">{item.name} · current {item.quantity} {item.unit}</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label className="text-sm font-semibold">Type</Label>
            <Select value={adjType} onValueChange={setAdjType}>
              <SelectTrigger className="border-brand-line" data-testid="adj-type"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="increase">Increase</SelectItem><SelectItem value="decrease">Decrease</SelectItem></SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5"><Label className="text-sm font-semibold">Quantity</Label>
            <Input type="number" value={qty} onChange={(e) => setQty(e.target.value)} className="border-brand-line" data-testid="adj-qty" />
          </div>
        </div>
        <div className="space-y-1.5"><Label className="text-sm font-semibold">Reason</Label>
          <Select value={reason} onValueChange={setReason}>
            <SelectTrigger className="border-brand-line" data-testid="adj-reason"><SelectValue /></SelectTrigger>
            <SelectContent>{REASONS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <DialogFooter><Button onClick={save} disabled={busy || !qty} data-testid="save-adjust" className="bg-brand-primary hover:bg-brand-primary-hover text-white rounded-sm w-full">Record Adjustment</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
